import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { DateTime } from 'luxon';

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
`;

const PointWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  margin-bottom: 1.5rem;
  padding: 1.5rem;
`;

const PointDisplay = styled.label`
font-size: 1.475rem;
  font-weight: bold;
  color: #10b981;
  text-align: left;
`;

const LabelDisplay = styled.label`
  
    font-size: 1.375rem;
  font-weight: bold;
  color: #black;
  text-align: left;
`;


const LargeButton = styled.button`
  padding: 1rem 2rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-size: 1.25rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover {
    background-color: #2980b9;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
`;

const TableHead = styled.thead`
  background-color: #f3f4f6;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9fafb;
  }
`;

const TableHeader = styled.th`
  padding: 12px;
  text-align: left;
  border-bottom: 2px solid #e5e7eb;
  font-weight: bold;
`;

const TableData = styled.td`
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
`;

const CreditButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: ${({ disabled }) => (disabled ? '#d1d5db' : '#10b981')};
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  transition: background-color 0.3s;
  &:hover {
    background-color: ${({ disabled }) =>
      disabled ? '#d1d5db' : '#059669'};
  }
`;
const PaginationWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PaginationButton = styled.button`
  padding: 10px 20px;
  margin: 0 5px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const PageInfo = styled.span`
  font-size: 16px;
`;

function Withdraw() {
  const [pointsBalance, setPointsBalance] = useState(0);
  const [message, setMessage] = useState(''); // 사용자에게 표시할 메시지
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalOrders, setTotalOrders] = useState(0);
  const [limit, setLimit] = useState(10); // Number of items per page

  useEffect(() => {
    fetchPointsBalance();
    fetchOrderList();
  }, []);

  const handleCreditAll = async () => {
    try {
      const response = await fetch('/Acution/credit-all-orders', {
        method: 'POST',
        credentials: 'include',
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        fetchPointsBalance();
        fetchOrderList();
      } else {
        console.error(data.error);
        setMessage(data.error || '포인트 적립 중 오류가 발생했습니다.');
      }
    } catch (error) {
      console.error('포인트 적립 중 오류 발생:', error);
      setMessage('포인트 적립 중 오류가 발생했습니다.');
    }
  };
  
  const fetchPointsBalance = async () => {
    try {
      const response = await fetch('/Acution/points-balance', {
        credentials: 'include',
      });
      const data = await response.json();
      if (response.ok) {
        setPointsBalance(data.points_balance);
      } else {
        console.error('포인트 잔액을 가져올 수 없습니다.');
        setMessage('포인트 잔액을 가져올 수 없습니다.');
      }
    } catch (error) {
      console.error('포인트 잔액 조회 중 오류 발생:', error);
      setMessage('포인트 잔액 조회 중 오류가 발생했습니다.');
    }
  };

  const fetchOrderList = async (page = currentPage) => {
    try {
      const response = await fetch(`/Acution/completed-orders?page=${page}&limit=${limit}`, {
        credentials: 'include',
      });
      const data = await response.json();
      if (response.ok) {
        setOrders(data.orders);
        setTotalPages(data.totalPages);
        setCurrentPage(data.currentPage);
        setTotalOrders(data.totalOrders);
      } else {
        console.error('주문 내역을 가져올 수 없습니다.');
        setMessage('주문 내역을 가져올 수 없습니다.');
      }
    } catch (error) {
      console.error('주문 내역 조회 중 오류 발생:', error);
      setMessage('주문 내역 조회 중 오류가 발생했습니다.');
    }
  };

  const handleCredit = async (menu_id) => {
    try {
      const response = await fetch('/Acution/credit-order', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ menu_id }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage('포인트가 성공적으로 적립되었습니다.');
        fetchPointsBalance();
        fetchOrderList();
      } else {
        console.error(data.error);
        setMessage(data.error || '포인트 적립 중 오류가 발생했습니다.');
      }
    } catch (error) {
      console.error('포인트 적립 중 오류 발생:', error);
      setMessage('포인트 적립 중 오류가 발생했습니다.');
    }
  };
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      fetchOrderList(newPage);
    }
  };
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = DateTime.fromISO(dateString, { zone: 'Asia/Seoul' });
    if (!date.isValid) return '';
    return date.toFormat('yyyy-MM-dd HH:mm');
  };

  const formatOnlyDate = (dateString) => {
    if (!dateString) return '';
    const date = DateTime.fromISO(dateString, { zone: 'Asia/Seoul' });
    if (!date.isValid) return '';
    return date.toFormat('yyyy-MM-dd');
  };
  const isCreditAvailable = (screeningDate) => {
    const today = DateTime.now().setZone('Asia/Seoul').startOf('day');
  
    // 날짜 형식을 확인 후 변환
    const screening = DateTime.fromISO(screeningDate, {
      zone: 'Asia/Seoul',
    }).plus({ days: 1 });
  
    // 상영일 + 1일 후 오늘 날짜와 비교
    return today >= screening;
  };

  return (
    <Container>
      
      <PointWrapper>
      <section>
      <LabelDisplay>내 포인트  </LabelDisplay><PointDisplay> {pointsBalance?.toLocaleString()} P</PointDisplay>
      </section>
        <LargeButton onClick={() => handleCreditAll()}>
          전체 포인트 정산
        </LargeButton>
      </PointWrapper>

      {message && <p>{message}</p>}

      {/* 정립 대기 내역 표 */}
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>대행완료일시</TableHeader>
            <TableHeader>대행 주문 번호</TableHeader>
            <TableHeader>금액</TableHeader>
            <TableHeader>상태</TableHeader>
            <TableHeader>상영일자</TableHeader>
            <TableHeader>액션</TableHeader>
          </TableRow>
        </TableHead>
        <tbody>
          {orders.map((order) => {
            const canCredit = isCreditAvailable(order.date);
            let statusText = '';

            if (order.agent_status === 'credited') {
              statusText = '포인트 적립 완료';
            } else if (canCredit) {
              statusText = '적립 가능';
            } else {
              statusText = '적립 불가';
            }

            return (
              <TableRow key={order.menu_id}>
                <TableData>{formatDate(order.completion_time)}</TableData>
                <TableData>{order.menu_id}</TableData>
                <TableData>{order.price?.toLocaleString()} 원</TableData>
                <TableData>{statusText}</TableData>
                <TableData>{formatOnlyDate(order.date)}</TableData>
                <TableData>
                  <CreditButton
                    onClick={() => handleCredit(order.menu_id)}
                    disabled={
                      order.agent_status === 'credited' || !canCredit
                    }
                  >
                    {order.agent_status === 'credited'
                      ? '적립 완료'
                      : canCredit
                      ? '적립 가능'
                      : '적립 불가'}
                  </CreditButton>
                </TableData>
              </TableRow>
            );
          })}
        </tbody>
      </Table>
      {/* Pagination Controls */}
<PaginationWrapper>
  <PaginationButton onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
    이전
  </PaginationButton>
  <PageInfo>
    페이지 {currentPage} / {totalPages}
  </PageInfo>
  <PaginationButton onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
    다음
  </PaginationButton>
</PaginationWrapper>
    </Container>
  );
}

export default Withdraw;